// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"65e4ffef","96":"d4eba796","192":"ba4cc21f","264":"744ed291","453":"2291aba8","613":"b06d5eae"}[chunkId] + ".chunk.js";
};